import script from "./Question.vue?vue&type=script&setup=true&lang=js"
export * from "./Question.vue?vue&type=script&setup=true&lang=js"

import "./Question.vue?vue&type=style&index=0&id=7d931936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d931936"]])

export default __exports__